import styled from 'styled-components'
import { flexDirection, FlexDirectionProps } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { LANDING_MAX_CONTENT_WIDTH_PX } from 'Constants/Landing'

const shouldForwardProp = (prop: string | number) => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Content = styled.div.withConfig({
  shouldForwardProp,
})<FlexDirectionProps>`
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: ${LANDING_MAX_CONTENT_WIDTH_PX}px;
  gap: ${themeGet('space.11')}px;

  ${flexDirection}
`
